import { Box } from "@mantine/core";
import { PlusIcon, DiscoveryIcon, RequestsIcon, IdeasIcon, ReportsIcon, CustomersDashboardIcon } from "../icons/x-symbol-svgrepo-com";
import { ExploreSparklesIcon } from "../icons/ExploreSparklesIcon";
import { ExploreBagelSparkleIcon } from "./explore/ExploreBagelSparkleIcon";

export const AppSkeleton = () => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      height: '100vh',
      overflow: 'hidden'
    }}>
      {/* Shell matches MainLayout: no top header; sidebar + main only */}
      <div style={{ display: 'flex', flex: 1, minHeight: 0, overflow: 'hidden' }}>
        {/* Navbar skeleton */}
        <div style={{ 
          width: '56px', 
          backgroundColor: '#F8F8FB',
          borderRight: '1px solid #D8D8DB',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingTop: '16px',
          paddingBottom: '12px',
          gap: '2px',
          flexShrink: 0,
        }}>
          {/* Logo — matches MainNav */}
          <div
            style={{
              alignSelf: "stretch",
              display: "flex",
              justifyContent: "flex-start",
              marginLeft: "12px",
              marginBottom: "10px",
            }}
          >
            {/* No react-router <Link>: skeleton renders outside <Router> during auth load — same logo as MainNav */}
            <a href="/" style={{ lineHeight: 0, display: "block" }}>
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    width: 28,
                    height: 28,
                    flexShrink: 0,
                    transform: "scale(1.142857)",
                    transformOrigin: "center center",
                    lineHeight: 0,
                  }}
                >
                  <ExploreBagelSparkleIcon variant="insights" showSparkles={false} />
                </Box>
              </Box>
            </a>
          </div>
          {/* Add New Idea icon */}
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '6px'
          }}>
            <PlusIcon />
          </div>
          
          {/* Navigation icons — order matches menuObj (Explore first) */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px' }}>
            <ExploreSparklesIcon size={22} color="#161832" />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px' }}>
            <DiscoveryIcon stroke={1.5} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px' }}>
            <RequestsIcon stroke={1.5} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px' }}>
            <IdeasIcon stroke={1.5} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px' }}>
            <ReportsIcon stroke={1.5} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px' }}>
            <CustomersDashboardIcon stroke={1.5} />
          </div>

          <div style={{ flex: 1, minHeight: '8px' }} />

          {/* Footer utilities — matches MainNav bottom stack (search, whats new, notifications, invite, avatar) */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '6px',
              marginLeft: '8px',
              alignSelf: 'stretch',
            }}
          >
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: i === 5 ? '50%' : '8px',
                  backgroundColor: '#E8E9F3',
                  flexShrink: 0,
                }}
              />
            ))}
          </div>
        </div>
        
        {/* Main content area */}
        <div style={{ 
          flex: 1, 
          backgroundColor: 'white',
          padding: '20px',
          overflow: 'auto'
        }}>
          {/* Page title skeleton */}
          <div style={{
            width: '80px',
            height: '31px',
            backgroundColor: '#E8E9F3',
            borderRadius: '4px',
            marginBottom: '13px'
          }} />
          
          {/* Tabs/filters row */}
          <div style={{
            display: 'flex',
            gap: '16px',
            height: '31px',
            marginBottom: '18px',
            alignItems: 'center'
          }}>
            {[1, 2, 3, 4, 5, 6].map(i => (
              <div key={i} style={{
                height: '100%',
                width: i === 1 ? '100px' : '70px',
                backgroundColor: 'transparent',
                borderBottom: i === 1 ? '3px solid #5C5CEB' : 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div style={{
                  width: '80%',
                  height: '12px',
                  backgroundColor: '#E8E9F3',
                  borderRadius: '4px'
                }} />
              </div>
            ))}
          </div>
          
          {/* Filter/Action buttons row */}
          <div style={{
            display: 'flex',
            gap: '8px',
            height: '32px',
            marginBottom: '18px',
            alignItems: 'center'
          }}>
            {[1, 2, 3].map(i => (
              <div key={i} style={{
                width: i === 2 ? '200px' : '90px',
                height: '100%',
                backgroundColor: '#F8F8FB',
                border: '1px solid #E8E9F3',
                borderRadius: '6px'
              }} />
            ))}
            <div style={{
              width: '32px',
              height: '100%',
              backgroundColor: '#F8F8FB',
              border: '1px solid #E8E9F3',
              borderRadius: '6px'
            }} />
          </div>
          
          {/* Table container with border */}
          <div style={{
            border: '1px solid #E8E9F3',
            borderRadius: '8px',
            overflow: 'hidden'
          }}>
            <div style={{
              display: 'flex',
              gap: '12px',
              padding: '10px 16px',
              backgroundColor: '#F8F9FA',
              borderBottom: '1px solid #E8E9F3'
            }}>
              <div style={{ flex: 2.5, height: '12px', backgroundColor: '#D8D8DB', borderRadius: '4px' }} />
              <div style={{ flex: 1.2, height: '12px', backgroundColor: '#D8D8DB', borderRadius: '4px' }} />
              <div style={{ flex: 1, height: '12px', backgroundColor: '#D8D8DB', borderRadius: '4px' }} />
              <div style={{ flex: 1.2, height: '12px', backgroundColor: '#D8D8DB', borderRadius: '4px' }} />
              <div style={{ flex: 1.5, height: '12px', backgroundColor: '#D8D8DB', borderRadius: '4px' }} />
              <div style={{ flex: 1, height: '12px', backgroundColor: '#D8D8DB', borderRadius: '4px' }} />
              <div style={{ width: '30px', height: '12px', backgroundColor: '#D8D8DB', borderRadius: '4px' }} />
            </div>
            
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((_, i) => (
              <div key={i} style={{
                display: 'flex',
                gap: '12px',
                padding: '14px 16px',
                borderBottom: i < 9 ? '1px solid #F0F0F0' : 'none',
                alignItems: 'center',
                backgroundColor: 'white'
              }}>
                <div style={{ flex: 2.5 }}>
                  <div style={{ width: '80%', height: '12px', backgroundColor: '#E8E9F3', borderRadius: '4px' }} />
                </div>
                <div style={{ flex: 1.2, display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <div style={{ width: '28px', height: '28px', backgroundColor: '#E8E9F3', borderRadius: '50%', flexShrink: 0 }} />
                  <div style={{ flex: 1, height: '12px', backgroundColor: '#E8E9F3', borderRadius: '4px' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ width: '90%', height: '12px', backgroundColor: '#E8E9F3', borderRadius: '4px' }} />
                </div>
                <div style={{ flex: 1.2 }}>
                  <div style={{ width: '70%', height: '12px', backgroundColor: '#E8E9F3', borderRadius: '4px' }} />
                </div>
                <div style={{ flex: 1.5 }}>
                  <div style={{ width: '85%', height: '12px', backgroundColor: '#E8E9F3', borderRadius: '4px' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ width: '70%', height: '12px', backgroundColor: '#E8E9F3', borderRadius: '4px' }} />
                </div>
                <div style={{ width: '30px', display: 'flex', justifyContent: 'center' }}>
                  <div style={{ width: '16px', height: '16px', backgroundColor: '#E8E9F3', borderRadius: '50%' }} />
                </div>
              </div>
            ))}
          </div>
          
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '16px',
            padding: '0 8px'
          }}>
            <div style={{ width: '80px', height: '14px', backgroundColor: '#E8E9F3', borderRadius: '4px' }} />
            <div style={{ display: 'flex', gap: '8px' }}>
              {[1, 2, 3, 4, 5].map(i => (
                <div key={i} style={{
                  width: '32px',
                  height: '32px',
                  backgroundColor: i === 1 ? '#5C5CEB' : '#F8F8FB',
                  border: i === 1 ? 'none' : '1px solid #E8E9F3',
                  borderRadius: '6px'
                }} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


